<template>
  <div class="pricing-card-line pricing-card-line--establishment">
    <span class="pricing-card-line__item"><slot /></span>
    <span class="pricing-card-line__type mr-1">{{ $t('establishment') }}:</span>
    <span class="pricing-card-line__value">
      <span v-if="value.gross !== value.net" class="pricing-card-line__gross">{{ Currency(value.gross) }}</span>
      <span class="pricing-card-line__net">{{ Currency(value.net) }}</span>
    </span>
  </div>
</template>

<script>
import { Currency } from '@/filters'
export default {
  props: {
    value: Object,
  },
  methods: {
    Currency(val) {
      return Currency(val, { currency: this.$store.state.enums.Currency })
    },
  },
}
</script>
